import React, { useEffect, useRef, useState } from "react";
import { Arrow, Calendar, DayTile, DaysDiv, InputContainer, MonthHeader, SelectDiv, WeekdayTile, } from "./styles";
import { addMonths, compareAsc, eachDayOfInterval, endOfDay, endOfMonth, endOfWeek, endOfYear, startOfDay, startOfMonth, startOfWeek, startOfYear, subDays, subMonths, subWeeks, } from "date-fns";
import { TiArrowSortedDown } from "react-icons/ti";
import { weekdays, months } from "../../../utils/constants";
import { fillDaysArray, formatDateToString, hexToRgb, } from "../../../utils/functions";
import { Spinner } from "../../Spinner/styles";
export var FullCalendar = function (_a) {
    var _b, _c, _d, _e;
    var value = _a.value, onDateSelected = _a.onDateSelected, hideFields = _a.hideFields, calendarColor = _a.calendarColor, isLoading = _a.isLoading, disabled = _a.disabled;
    var now = new Date();
    var customColor = calendarColor ? calendarColor : "#ff2c3a";
    var hoverCustomColor = hexToRgb(customColor).hover;
    var calendarRef = useRef();
    var _f = useState(0), leftDistance = _f[0], setLeftDistance = _f[1];
    var _g = useState(false), showCalendar = _g[0], setShowCalendar = _g[1];
    var _h = useState({
        value: startOfDay(value.start),
        day: value.start.getDate(),
        month: value.start.getMonth(),
        year: value.start.getFullYear(),
        weekday: value.start.getDay()
    }), dayClicked = _h[0], setDayClicked = _h[1];
    var _j = useState({
        value: startOfDay(value.end || value.start),
        day: ((_b = value.end) === null || _b === void 0 ? void 0 : _b.getDate()) || value.start.getDate(),
        month: ((_c = value.end) === null || _c === void 0 ? void 0 : _c.getMonth()) || value.start.getMonth(),
        year: ((_d = value.end) === null || _d === void 0 ? void 0 : _d.getFullYear()) || value.start.getFullYear(),
        weekday: ((_e = value.end) === null || _e === void 0 ? void 0 : _e.getDay()) || value.start.getDay()
    }), dayHovered = _j[0], setDayHovered = _j[1];
    var _k = useState(value.end
        ? eachDayOfInterval({ start: value.start, end: value.end })
        : [value.start]), daysOnRange = _k[0], setDaysOnRange = _k[1];
    var _l = useState(false), isSelecting = _l[0], setIsSelecting = _l[1];
    var _m = useState({
        start: startOfMonth(now),
        end: endOfMonth(now)
    }), monthToShow = _m[0], setMonthToShow = _m[1];
    var _o = useState([]), daysToShow = _o[0], setDaysToShow = _o[1];
    var _p = useState(startOfDay(value.start)), firstDay = _p[0], setFirstDay = _p[1];
    var _q = useState(startOfDay(value.end)), lastDay = _q[0], setLastDay = _q[1];
    var checkHide = function (field) {
        return !(hideFields === null || hideFields === void 0 ? void 0 : hideFields.includes(field));
    };
    useEffect(function () {
        var daysOfTheMonth = eachDayOfInterval(monthToShow);
        fillDaysArray(daysOfTheMonth);
        setDaysToShow(daysOfTheMonth.map(function (day) {
            return {
                value: day,
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear(),
                weekday: day.getDay()
            };
        }));
    }, [monthToShow]);
    var getDayRange = function () {
        var start = compareAsc(dayClicked.value, dayHovered.value) === 1
            ? dayHovered
            : dayClicked;
        var end = compareAsc(dayClicked.value, dayHovered.value) === 1
            ? dayClicked
            : dayHovered;
        setDaysOnRange(eachDayOfInterval({ start: start.value, end: end.value }));
    };
    useEffect(function () {
        if (dayClicked && dayHovered) {
            getDayRange();
        }
    }, [dayHovered]);
    useEffect(function () {
        setFirstDay(daysOnRange[0]);
        setLastDay(daysOnRange[daysOnRange.length - 1]);
    }, [daysOnRange]);
    useEffect(function () {
        window.addEventListener("click", function () {
            setShowCalendar(false);
        });
    }, []);
    useEffect(function () {
        if (calendarRef.current) {
            setLeftDistance(calendarRef.current.getBoundingClientRect().left);
        }
    }, [calendarRef]);
    return (React.createElement("div", { ref: calendarRef, style: {
            position: "relative",
            width: "fit-content",
            pointerEvents: isLoading || disabled ? "none" : "all"
        }, onClick: function (e) { return e.stopPropagation(); } },
        React.createElement(Arrow, { show: showCalendar }),
        React.createElement(InputContainer, { customColor: customColor, disabled: disabled, onClick: function () {
                setShowCalendar(!showCalendar);
            } },
            React.createElement("p", null,
                firstDay ? formatDateToString(firstDay) : "",
                " "),
            React.createElement("span", null, " a "),
            React.createElement("p", null,
                lastDay ? formatDateToString(lastDay) : "",
                " "),
            isLoading ? (React.createElement(Spinner, { background: "#666", inverted: true, size: 10, style: { margin: "0 4px" } })) : (React.createElement(TiArrowSortedDown, { color: disabled ? "#666" : customColor, size: 25 }))),
        React.createElement(Calendar, { show: showCalendar, leftDistance: leftDistance },
            React.createElement(SelectDiv, null,
                checkHide("today") && (React.createElement("span", { onClick: function () {
                        var today = startOfDay(new Date());
                        setFirstDay(today);
                        setLastDay(endOfDay(today));
                        setDaysOnRange([today]);
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({ start: today, end: endOfDay(today) });
                        }
                    } }, "Hoje")),
                checkHide("yesterday") && (React.createElement("span", { onClick: function () {
                        var yesterday = startOfDay(subDays(new Date(), 1));
                        setFirstDay(yesterday);
                        setLastDay(endOfDay(yesterday));
                        setDaysOnRange([yesterday]);
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({
                                start: yesterday,
                                end: endOfDay(yesterday)
                            });
                        }
                    } }, "Ontem")),
                checkHide("this_week") && (React.createElement("span", { onClick: function () {
                        var thisWeek = startOfWeek(new Date());
                        setFirstDay(thisWeek);
                        setLastDay(endOfWeek(thisWeek));
                        setDaysOnRange(eachDayOfInterval({
                            start: thisWeek,
                            end: endOfWeek(thisWeek)
                        }));
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({ start: thisWeek, end: endOfWeek(thisWeek) });
                        }
                    } }, "Essa semana")),
                checkHide("last_week") && (React.createElement("span", { onClick: function () {
                        var lastWeek = startOfWeek(subWeeks(new Date(), 1));
                        setFirstDay(startOfWeek(subWeeks(new Date(), 1)));
                        setLastDay(endOfWeek(lastWeek));
                        setDaysOnRange(eachDayOfInterval({
                            start: lastWeek,
                            end: endOfWeek(lastWeek)
                        }));
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({ start: lastWeek, end: endOfWeek(lastWeek) });
                        }
                    } }, "Semana anterior")),
                checkHide("this_month") && (React.createElement("span", { onClick: function () {
                        var thisMonth = startOfMonth(new Date());
                        setFirstDay(thisMonth);
                        setLastDay(endOfMonth(thisMonth));
                        setDaysOnRange(eachDayOfInterval({
                            start: thisMonth,
                            end: endOfMonth(thisMonth)
                        }));
                        setMonthToShow({
                            start: thisMonth,
                            end: endOfMonth(thisMonth)
                        });
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({
                                start: thisMonth,
                                end: endOfMonth(thisMonth)
                            });
                        }
                    } }, "Esse m\u00EAs")),
                checkHide("last_month") && (React.createElement("span", { onClick: function () {
                        var lastMonth = startOfMonth(subMonths(new Date(), 1));
                        setFirstDay(lastMonth);
                        setLastDay(endOfMonth(lastMonth));
                        setDaysOnRange(eachDayOfInterval({
                            start: lastMonth,
                            end: endOfMonth(lastMonth)
                        }));
                        setMonthToShow({
                            start: lastMonth,
                            end: endOfMonth(lastMonth)
                        });
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({
                                start: lastMonth,
                                end: endOfMonth(lastMonth)
                            });
                        }
                    } }, "M\u00EAs anterior")),
                checkHide("this_year") && (React.createElement("span", { onClick: function () {
                        var thisYear = startOfYear(new Date());
                        setFirstDay(thisYear);
                        setLastDay(endOfYear(thisYear));
                        setDaysOnRange(eachDayOfInterval({
                            start: thisYear,
                            end: endOfYear(thisYear)
                        }));
                        setShowCalendar(false);
                        if (onDateSelected) {
                            onDateSelected({ start: thisYear, end: endOfYear(thisYear) });
                        }
                    } }, "Esse ano"))),
            React.createElement("div", null,
                React.createElement(MonthHeader, { customColor: customColor },
                    React.createElement("div", null),
                    React.createElement("span", null, monthToShow.start.getFullYear()),
                    React.createElement("div", null)),
                React.createElement(MonthHeader, { customColor: customColor, style: { borderRadius: 0 } },
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: subMonths(monthToShow.start, 1),
                                end: subMonths(monthToShow.end, 1)
                            });
                        }, color: customColor, size: 25, style: {
                            transform: "rotate(90deg)"
                        } }),
                    React.createElement("span", null, months[monthToShow.start.getMonth()]),
                    React.createElement(TiArrowSortedDown, { onClick: function () {
                            return setMonthToShow({
                                start: addMonths(monthToShow.start, 1),
                                end: addMonths(monthToShow.end, 1)
                            });
                        }, color: customColor, size: 25, style: {
                            transform: "rotate(-90deg)"
                        } })),
                React.createElement(DaysDiv, null,
                    weekdays.map(function (wd, i) { return (React.createElement(WeekdayTile, { idx: i }, wd)); }),
                    daysToShow.map(function (day, i) {
                        return (React.createElement(DayTile, { key: i, day: day, clicked: (dayClicked === null || dayClicked === void 0 ? void 0 : dayClicked.value) === day.value, customColor: customColor, hoverCustomColor: hoverCustomColor, isSelecting: isSelecting, isThisMonth: day.month !== monthToShow.start.getMonth(), isOnRange: daysOnRange.some(function (d) { return compareAsc(d, day.value) === 0; }), isFirst: compareAsc(firstDay, day.value) === 0, isLast: compareAsc(lastDay, day.value) === 0, onClick: function () {
                                if (isSelecting && onDateSelected) {
                                    onDateSelected({
                                        start: firstDay,
                                        end: lastDay ? endOfDay(lastDay) : null
                                    });
                                    setShowCalendar(false);
                                }
                                else if (!isSelecting && onDateSelected) {
                                    setDaysOnRange([day.value]);
                                }
                                setIsSelecting(!isSelecting);
                                setDayClicked(day);
                            }, onMouseOver: function () {
                                if (isSelecting) {
                                    setDayHovered(day);
                                }
                            } }, day.day));
                    }))))));
};
//# sourceMappingURL=index.js.map